module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00155.f3e84c70.jpg";